import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "src/app/core/services/order.service";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-scan",
  templateUrl: "./scan.component.html",
  styleUrls: ["./scan.component.css"],
})
export class ScanComponent implements OnInit {
  loading = true;
  logo: string = "";
  public urlHost = "";
  public mesa:string = "";
  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router,
    private modalService: NgbModal
  ) {
    this.urlHost = environment.urlHostImage;
  }

  ngOnInit() {
    const id = this.route.snapshot.params.id;
    this.validate(id);
    this.getLogo();
    
  }

  async validate(id){
    let result = await this.orderService.validate(id);
    if (result) {
      this.loading = false;
      this.mesa = this.orderService.getMesa();
      this.router.navigate(["/inicio"]);
    } else {
      //window.location.href = "https://2mnu.com";
    }
  }

  async getLogo() {
    this.logo = await this.orderService.getLogo();
    this.logo = this.urlHost + "images/logo/" + this.logo;
  }
}
